/**
 * Single source for the Durgotsav venue — used by the hero CTA and by the
 * WhatsApp share text, so the map pin never drifts between the two.
 *
 * MAP_URL is the pin people navigate to; the address lines are what they read
 * in a chat before tapping it.
 */
export const VENUE_MAP_URL = "https://maps.app.goo.gl/bkQcrr9CeBtidip56";

export const VENUE_NAME = "SORRBA Durgotsav Venue";

export const VENUE_ADDRESS_LINES = [
  "Sarjapur Road, Bengaluru, Karnataka 560102",
];

export const VENUE_ADDRESS = VENUE_ADDRESS_LINES.join(", ");
